export default [
  {
    label: "",
    id: "step1",
    items: [
      {
        label: "Поля",
        link: "catalog/fields"
      },
      {
        label: "Машины",
        link: "catalog/cars"
      },
      // {
      //   label: "Орудия",
      //   link: "catalog/organization-instruments"
      // },
      {
        label: "Орудия хозяйства",
        link: "catalog/organization-instruments-new"
      },
      {
        label: "Статусы машин",
        link: "catalog/car-statuses"
      },
      {
        label: "Интеграция с GPS",
        link: "catalog/car-gps-identifier"
      },
      {
        label: "Датчики",
        link: "catalog/car-sensors"
      },
      {
        label: "Настройка ДУТ",
        link: "catalog/tank-car-sensor-setting"
      },
      {
        label: "НВ основных работ",
        link: "catalog/primary-work-norms"
      },
      {
        label: "Семена хозяйства",
        link: "catalog/seed-prices"
      },
      {
        label: "RFID",
        link: "catalog/rfid"
      },
      {
        label: "Водители",
        link: "catalog/employees"
      },
    ]
  }
];
